import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnInit,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { fade, openClose } from '@core/animations/animations';
import { BrokerageType, MatterFileType } from '@models/matter';
import { BehaviorSubject, Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { Select } from '@ngxs/store';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { TestHooks } from './multiple-commissions.hooks';

@UntilDestroy()
@Component({
	selector: 'app-multiple-commissions',
	templateUrl: './multiple-commissions.component.html',
	styleUrls: ['./multiple-commissions.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	animations: [fade(), openClose(300)],
	standalone: false,
})
export class MultipleCommissionsComponent implements OnInit {
	testHooks = TestHooks;
	public brokerageTypeDisplayName$: Observable<string>;
	public isClientBrokerage$: Observable<boolean>;

	public selectedBrokerageType$ = new BehaviorSubject(
		BrokerageType.SELLER_BROKERAGE,
	);
	@Input() set selectedBrokerageType(brokerageType: BrokerageType) {
		this.selectedBrokerageType$.next(brokerageType);
	}

	@Select(SelectedMatter.matterFileType)
	matterFileType$: Observable<MatterFileType>;

	ngOnInit(): void {
		this.brokerageTypeDisplayName$ = this.selectedBrokerageType$.pipe(
			untilDestroyed(this),
			map((x) => {
				if (x === BrokerageType.BUYER_BROKERAGE) return 'Buyer';
				if (x === BrokerageType.SELLER_BROKERAGE) return 'Seller';
				return '';
			}),
		);

		this.isClientBrokerage$ = combineLatest([
			this.selectedBrokerageType$,
			this.matterFileType$,
		]).pipe(
			untilDestroyed(this),
			map(([brokerageType, matterFileType]) => {
				return (
					(matterFileType === MatterFileType.SALE &&
						brokerageType === BrokerageType.SELLER_BROKERAGE) ||
					(matterFileType === MatterFileType.PURCHASE &&
						brokerageType === BrokerageType.BUYER_BROKERAGE)
				);
			}),
		);
	}
}
